@if (!isNewChecklistInput) {
  <app-custom-input-overlay-dropdown
    #checkListOverlay
    [(model)]="model.name"
    [isEdited]="isEdited"
    [autoComplete]="false"
    [iconClass]="
      checkListOverlay.isDropdownShown ? '-mt-1 mr-1 dropdown-icon opened' : ' -mt-1 mr-1 dropdown-icon closed'
    "
    [required]="required"
    class="cursor-pointer"
    label="Checklist"
    name="checklist"
    placeholder="Checklist"
  >
    <app-checklist-dropdown
      [showNoChecklistOption]="false"
      (selectedOption)="checkListOptionSelected($event); checkListOverlay.hideDropdown()"
      [checkLists]="getAllCheckList$ | async"
      [width]="checkListOverlay?.floatingInputComponent?.inputElement()?.nativeElement?.clientWidth"
      [selectedId]="model.template_id"
    >
      <ng-template>
        <div class="text-red-200 icon-minus-box cursor-pointer"></div>
      </ng-template>
    </app-checklist-dropdown>
  </app-custom-input-overlay-dropdown>
}

@if (isNewChecklistInput) {
  <app-floating-input
    (iconClick)="checkListOptionSelected({ action: SELECTED_OPTION.DESELECT })"
    iconClass="icon-refresh mr-1 cursor-pointer text-blue-700 hover:text-red-500"
    [(ngModel)]="model.name"
    label="New Checklist Name"
    name="checklistInput"
    placeholder="New Checklist Name"
    required
  >
  </app-floating-input>
}

@for (item of model?.items; track $index; let index = $index) {
  <div class="flex gap-2.5 items-center align-baseline">
    <div class="grid grid-cols-2 gap-2.5">
      <app-floating-input
        required
        [(ngModel)]="item.name"
        [label]="'Checklist Item ' + (index + 1 | number)"
        [name]="'checklistItem_' + ((index | number) + 1)"
        [placeholder]="'Checklist Item ' + (index + 1 | number)"
      ></app-floating-input>
      <app-input-calendar
        required
        placeholder="Due Date"
        [date]="model?.items[index]?.end_date"
        [name]="'checklist_item_due_date_' + ((index | number) + 1)"
        [showIcon]="true"
        (dateChanged)="updateModelDate($event, index)"
        [minStartDate]="minStartDate"
        [maxDate]="maxDate"
      ></app-input-calendar>
    </div>
    <div (click)="deleteItem(index)" class="text-blue-700 icon-minus-box cursor-pointer pt-5 pb-0.5"></div>
    <div (click)="insertItem(index)" class="text-red-200 icon-plus-box cursor-pointer pt-5 pb-0.5"></div>
  </div>
}
